/**
 * Created by Daniela on 23/01/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { editRoute, newRoute } from "../../shared/services/data.service";
import { TipoAjusteListComponent } from "./tipo-ajuste-list/tipo-ajuste-list.component";
import { TipoAjusteFormComponent } from "./tipo-ajuste-form/tipo-ajuste-form.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class TipoAjustesRoutingModule {}

export const tipoAjustesRoutes: any[] = [
    {
        path: '',
        component: TipoAjusteListComponent
    },{
        path: editRoute + '/:id',
        component: TipoAjusteFormComponent
    },{
        path: newRoute,
        component: TipoAjusteFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/tipo-ajustes-routing.module.ts
 **/